export const maskPlaca = [/[A-Za-z]/, /[A-Za-z]/, /[A-Za-z]/, '-', /\d/, /[\dA-Za-z]/, /\d/, /\d/]